import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { HbaseObjectDataset } from 'app/model/dataset/hbase.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'HBaseSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(HbaseObjectDataset) }
})
export class HbaseCopySource extends TabularCopySource {
}
